import { boolPropsToClassNames } from 'common/utils/style.utils';
import {
  StyledVerticalMenu,
  StyledVerticalMenuOption,
  StyledVerticalMenuOptionText
} from './VerticalMenu.style';

const VerticalMenu = ({ options, value, onChange }) => {
  return (
    <StyledVerticalMenu>
      {Object.values(options).map(option => {
        const isSelected = option.value === value;

        return (
          <StyledVerticalMenuOption key={option.value}>
            <StyledVerticalMenuOptionText
              className={boolPropsToClassNames({ isSelected })}
              {...(isSelected ? {} : { onClick: () => onChange(option) })}
            >
              {option.name}
            </StyledVerticalMenuOptionText>
          </StyledVerticalMenuOption>
        );
      })}
    </StyledVerticalMenu>
  );
};

export default VerticalMenu;
